export const checkIsTimePassed = (time) => {
    const now = Math.floor(Date.now() / 1000);
    return now > time;
};
//# sourceMappingURL=check-is-time-passed.js.map